<script setup lang="ts"></script>

<template>
  <div>
    <BillingDetails />
    <hr class="my-8" />
    <CardDetails />
  </div>
</template>
